import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import { selectTheme, toggleTheme } from "../features/dashboard/layoutSlice";
import LightMode from "@mui/icons-material/LightMode";
import DarkMode from "@mui/icons-material/DarkMode";
import { useAppSelector } from "../hooks/storeHooks";

const DarkModeToggle = () => {
  const dispatch = useDispatch();
  const themeMode = useAppSelector(selectTheme);
  return (
    <IconButton onClick={() => dispatch(toggleTheme())} color="inherit">
      {themeMode === "EnergyGainDarkTheme" ? <LightMode /> : <DarkMode />}
    </IconButton>
  );
};

export default DarkModeToggle;
